
import React, { useState } from 'react';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import SyllabusSection from './components/SyllabusSection';
import PracticesSection from './components/PracticesSection';
import PricingSection from './components/PricingSection';
import EnrollmentSection from './components/EnrollmentSection';
import Footer from './components/Footer';

const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <HeroSection />
      <AboutSection />
      <SyllabusSection />
      <PricingSection />
      <PracticesSection />
      <EnrollmentSection />
      <Footer />
    </div>
  );
};

export default HomePage;
